
<div class='container-fluid messages-compact no-gutters'>
    <div *ngIf="isLoading" class="loading" style='height: 100%;'>
        <mat-spinner *ngIf="true" mode="indeterminate"></mat-spinner>
    </div>
    <app-table-view 
    (onPaginationBtnClick)='paginationHandler($event)' [paginatorInfo]='paginatorInfo'
    [showPaginatian]='true' [controls]="tableControls" (eventHandeler)="tableEventHandeler($event)">
   </app-table-view>
        

</div>